<template>
  <Transition name="fade">
    <div
      v-if="!dismissed"
      :class="[
        'alert',
        `alert-${props.variant}`,
        props.dismissable && 'alert-dismissible',
        props.class,
      ]"
      role="alert"
    >
      <i v-if="icon" :class="`bx ${icon}`" aria-hidden="true" />
      <slot />
      <button
        v-if="props.dismissable"
        type="button"
        class="btn-close"
        aria-label="Close"
        @click="dismissed = true"
      />
    </div>
  </Transition>
</template>

<script setup>
import { ref } from 'vue'
import { THEME_VARIANTS } from '@shared/constants/bootstrap'

const dismissed = ref(false)

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  class: { type: null, required: false },
  icon: {
    type: String,
    default: null,
  },
  variant: {
    type: String,
    required: false,
    default: 'primary',
    validator: (val) => THEME_VARIANTS.includes(val),
  },
  dismissable: { type: Boolean, required: false, default: false },
})
</script>

<style scoped>
.fade-enter-active {
  animation: fade-in 0.5s;
}

.fade-leave-active {
  animation: fade-out 0.5s;
}
</style>
